import { Tooltip } from 'antd';
import FiguresTooltip from '../FiguresTooltip';

const Mufta = props => {
    const { width, research, style, title, date, toDepth } = props;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const height = (bottom - roof) * 16 + 16;

    // const regexp = /^(\d+)(px)$/;
    // const widthInt = Number(regexp.exec(width)[1]);

    const widthInt = width;
    const lineHeight = height;
    const rectangleHeight = height - 16;
    const linePosition = height / 2;
    const arrowLength = widthInt / 12.8;
    const linePosition1 = widthInt;
    const linePosition2 = widthInt - arrowLength + 0.5;
    const lineEnd = widthInt - widthInt / (64 / 9);

    return (
        <Tooltip
            title={<FiguresTooltip title={title} roof={roof} bottom={bottom} date={date} />}
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg width={widthInt} height={height} xmlns="http://www.w3.org/2000/svg" fill="none" style={style}>
                <g>
                    <title>Layer 1</title>
                    <path
                        id="middle_line"
                        fill="#7E8DA9"
                        d={`m0,${linePosition}l${arrowLength},2.8868l0,-5.7736l-${arrowLength},2.8868zm${linePosition1},0l-${arrowLength},-2.8868l0,5.7736l${arrowLength},-2.8868zm-${linePosition2},0.5l${lineEnd},0l0,-1l-${lineEnd},0l0,1z`}
                    />
                    <path
                        id="right_line"
                        fill="#7E8DA9"
                        d={`m${widthInt - 16 + 0.5},0l0,${lineHeight}l-1,0l0,-${lineHeight}l1,0z`}
                    />
                    <path
                        id="right_rectangle"
                        stroke="#7E8DA9"
                        d={`m${widthInt - 16},8l6,0l0,${rectangleHeight}l-6,0`}
                    />
                    <path id="left_line" fill="#7E8DA9" d={`m15.5,0l0,${lineHeight}l1,0l0,-${lineHeight}l-1,0z`} />
                    <path id="left_rectangle" stroke="#7E8DA9" d={`m16,8l-6,0l0,${rectangleHeight}l6,0`} />
                </g>
            </svg>
        </Tooltip>
    );
};

export default Mufta;
